import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-2 16H5V5h14v14z"
}), 'CropDinSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropDinSharp.js
// module id = 3007
// module chunks = 2